// Image Lazy Loader
// Adds loading="lazy" to images below the fold for performance improvement
// Shopify's default is eager loading, so we only affect images without explicit loading attribute

(function() {
    'use strict';

    // Don't run if Shopify's native lazy loading is already enabled
    if (window.Shopify && Shopify.img && Shopify.img.onLazyLoad) {
        console.log('Image Lazy Loader: Shopify native lazy loading is enabled');
        return;
    }

    // Add lazy loading to images below the fold
    function addLazyLoading() {
        var images = document.querySelectorAll('img:not([loading])');
        images.forEach(function(img) {
            // Only apply to images below the fold
            if (img.getBoundingClientRect().top > window.innerHeight * 0.8) {
                img.setAttribute('loading', 'lazy');
            }
        });
    }

    // Run once on load
    addLazyLoading();

    // Re-run on resize
    window.addEventListener('resize', function() {
        // Debounced re-check
        clearTimeout(window.__lazyLoaderTimeout);
        window.__lazyLoaderTimeout = setTimeout(function() {
            addLazyLoading();
        }, 200);
    });
})();
